// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"d365321d","106":"2ecf5603","109":"0b164947","486":"e5480857","510":"47766e9d","639":"2ecf5603","644":"0b164947"}[chunkId] + ".chunk.css";
};